import { Typography } from '@mui/material';

export function SubHeading({ title }: { title: string }) {
  return (
    <Typography variant='faded' fontSize={18} sx={{ textTransform: 'uppercase' }}>
      {title}
    </Typography>
  );
}
